const patternEmail = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
const patternPhone = /^(?:(?:1\s?)?(?:\(?\d{3}\)?[\s-]?\d{3}[\s-]?\d{4})|(?:(?:\+44\s?(?:\(0\)\s?)?|0)(?:\d[\s-]?){9,10}))$/;
const patternPassword = {
    upper_lower_number: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s)(?=.*[@_!$%^&#*)(.-]).{8,32}.*$/
}
const patternDomain = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/;
const onlyFourCharacter = /^[(0-9)|(a-z)|(A-Z)]{4,4}$/;

export {patternEmail, patternPhone, patternPassword, patternDomain, onlyFourCharacter};
